<template>
    <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M3.95895 9.803L3.43753 10.0437C3.05989 10.4089 3.05989 11.001 3.43753 11.3662L3.682 11.5964L5.63214 11.7051H17.1061C17.4208 11.7051 17.6758 11.6138 17.871 11.4311C18.0599 11.2424 18.1543 11.0019 18.1543 10.7096C18.1543 10.4113 18.0599 10.1708 17.871 9.98818C17.6758 9.79945 17.4208 9.70508 17.1061 9.70508H5.63214L3.95895 9.803Z"
            fill="black"
        />
        <path
            d="M6.8457 5.70508L2.55281 9.99797C2.16228 10.3885 2.16229 11.0217 2.55281 11.4122L6.8457 15.7051"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
        />
    </svg>
</template>
